// HomeHub image carousel (Problem section). Prev/next + dot navigation,
// wrapping, keeps the active dot in sync. One-slide-at-a-time horizontal track.
class HHCarousel extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this._wired = true;

    this.track = this.querySelector('[ref="track"]');
    this.slides = [...this.querySelectorAll('.hh-problem__slide')];
    this.dots = [...this.querySelectorAll('.hh-problem__dot')];
    this.prevBtn = this.querySelector('[ref="prev"]');
    this.nextBtn = this.querySelector('[ref="next"]');
    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.prevBtn?.addEventListener('click', () => this.go(this.index - 1));
    this.nextBtn?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.hhSlide, 10)));
    });
  }

  go(i) {
    const n = this.slides.length;
    this.index = (i + n) % n; // wrap
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
    this.dots.forEach((d, di) => {
      const on = di === this.index;
      d.classList.toggle('hh-problem__dot--active', on);
      if (on) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('hh-carousel')) {
  customElements.define('hh-carousel', HHCarousel);
}
